<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Excel Export</h5>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <p class="mb-3 text-muted">
            Wähle eine Excel-Vorlage (.xlsx) aus und starte den Export.
          </p>

          <div class="mb-3">
            <label class="form-label" for="excelTemplateSelect">Vorlage</label>
            <select id="excelTemplateSelect" class="form-select" v-model="selectedTemplateId">
              <option disabled value="">Bitte Vorlage auswählen</option>
              <option v-for="template in templates" :key="template.id" :value="template.id">
                {{ template.originalFileName }} ({{ template.fileType }})
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label" for="excelOutputFileName">Dateiname (optional)</label>
            <input
              id="excelOutputFileName"
              class="form-control"
              type="text"
              v-model.trim="outputFileName"
              placeholder="z. B. rechnung-export.xlsx"
            />
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <small v-if="loadingTemplates" class="text-muted">Vorlagen werden geladen...</small>
            <small v-else-if="templates.length === 0" class="text-warning">
              Keine Excel-Vorlagen gefunden.
            </small>
            <button type="button" class="btn btn-link p-0" @click="goToTemplateAdmin">
              Vorlagen verwalten
            </button>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Abbrechen</button>
          <button type="button" class="btn btn-primary" :disabled="!selectedTemplateId || loadingTemplates" @click="submitExport">
            Export starten
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileTemplateService from "@/services/FileTemplateService";

export default {
  name: "ExcelExportModal",
  emits: ["close", "export"],
  data() {
    return {
      templates: [],
      selectedTemplateId: "",
      outputFileName: "",
      loadingTemplates: false,
    };
  },
  methods: {
    async loadTemplates() {
      this.loadingTemplates = true;
      try {
        const response = await FileTemplateService.getInvoiceTemplates(FileTemplateService.EXCEL_FILE_TYPES);
        this.templates = Array.isArray(response?.data) ? response.data : [];
      } catch (error) {
        console.error("Failed to load Excel templates:", error);
      } finally {
        this.loadingTemplates = false;
      }
    },
    submitExport() {
      this.$emit("export", {
        templateFileId: this.selectedTemplateId,
        outputFileName: this.outputFileName || null,
      });
    },
    goToTemplateAdmin() {
      this.$emit("close");
      this.$router.push({ name: "TemplateAdmin" });
    },
  },
  mounted() {
    this.loadTemplates();
  },
};
</script>

<style scoped>
.modal.fade.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
